<div
  [@toastTrigger]="(toast.showsToast$ | async) ? 'open' : 'close'"
  [class]="toast.toastState$ | async"
  *ngIf="message"
  [ngClass]="showToastMoved ? 'toast-moved' : ''"
  class="toast">
  <div class="d-flex card-toast">
    <div class="icon">
      <sit-icon class="d-md-flex" [icon]="generateIcon(message.layer)"
                alt="Icono tipo de notificación" [sizeClass]="'icon-size-800'"></sit-icon>
    </div>
    <div class="content">
      <div class="title">
        <span>{{message.title}}</span>
      </div>
      <div class="body">
        <span>{{message.value}}</span>
      </div>
      <div class="footer d-flex">
        <div>
          <sit-icon class="d-md-flex" [icon]="Icon.CalendarIconNotify"
                    alt="Icono tipo de notificación" [sizeClass]="'icon-size-12'"></sit-icon>
          {{message.date}}
        </div>

        <div>
          <sit-icon class="d-md-flex" [icon]="Icon.LocationIconNotify"
                    alt="Icono tipo de notificación" [sizeClass]="'icon-size-12'"></sit-icon>
          {{message.location}}
        </div>
      </div>
    </div>
  </div>
</div>
